import { render, staticRenderFns } from "./Surveys.vue?vue&type=template&id=b99c964a&scoped=true"
import script from "./Surveys.vue?vue&type=script&lang=js"
export * from "./Surveys.vue?vue&type=script&lang=js"
import style0 from "./Surveys.vue?vue&type=style&index=0&id=b99c964a&prod&lang=scss"
import style1 from "./Surveys.vue?vue&type=style&index=1&id=b99c964a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99c964a",
  null
  
)

export default component.exports